import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Btn, Input, Field, Select } from "@/components/ui-kit";
import { AuthShell, Notice } from "@/components/AuthShell";
import { ROLE_LABELS } from "@/lib/constants";

const ROLES = ["technician", "supervisor", "inventory_manager"];

export default function Register() {
  const [f, setF] = useState({ full_name: "", email: "", password: "", requested_role: "technician" });
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", { ...f, email: f.email.trim() });
      setMsg({ tone: "ok", text: data.message, done: true });
    } catch (err) {
      setMsg({ tone: "err", text: apiError(err.response?.data?.detail) });
    }
    setBusy(false);
  };

  return (
    <AuthShell title="Request Access" subtitle="The Manager reviews every request before you can sign in.">
      {msg?.done ? (
        <Notice data-testid="register-message">{msg.text}</Notice>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <Field label="Full Name" required><Input data-testid="register-name" value={f.full_name} onChange={set("full_name")} required /></Field>
          <Field label="Email" required><Input data-testid="register-email" type="email" value={f.email} onChange={set("email")} required /></Field>
          <Field label="Password" required><Input data-testid="register-password" type="password" value={f.password} onChange={set("password")} required minLength={8} /></Field>
          <Field label="Role requested">
            <Select data-testid="register-role" value={f.requested_role} onChange={set("requested_role")}>
              {ROLES.map((r) => <option key={r} value={r}>{ROLE_LABELS[r]}</option>)}
            </Select>
          </Field>
          <Btn type="submit" size="lg" className="w-full" disabled={busy} data-testid="register-submit">
            {busy ? "Submitting…" : "Submit request"}
          </Btn>
          {msg && <Notice tone={msg.tone} data-testid="register-message">{msg.text}</Notice>}
        </form>
      )}
    </AuthShell>
  );
}
